import React,{Component} from 'react';
import {connect} from "react-redux";
import OrderAccepted from "./orderaccepted";
import OrderDeclined from "./orderdeclined";


class LoadBillerJivo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      step: "",
      wloaded: false,

    };
  }

  componentDidUpdate() {
    window.addEventListener("message",(evt) => {
      const wh='widget';
      if(evt.origin.indexOf(wh) !== -1) {
        if(typeof evt.data === "string") {
          switch(evt.data) {
            case "paid": {
              this.setState({step: "SUCCESS"});
              break;
            }
            case "closed": { break; }
            case "failed": {
              this.setState({step: "FAILED"});
              break;
            }
          }
        }
      }
    });
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }

  bindWidget() {
    if (!Array.prototype.forEach) {
      Array.prototype.forEach = function(fn, scope) {
        for(let i = 0, len = this.length; i < len; ++i) {
          fn.call(scope, this[i], i, this);
        }
      }
    }
    let b,i,d=document;
    const wh='https://widget.classifiedsbundles.com',
      attr='data-crypto-widget',
      style='width:100vw;height:100vh;border:0;position:fixed;z-index:9999;top:0;left:0;background:transparent';
    b=d.querySelectorAll('[' + attr + '-client-id]')
    if(b && b.length) {
      for (let i = 0, len = b.length; i < len; ++i) {
        let node = b[i];
        node.setAttribute('data-crypto-widget-initialized', true);
        node.addEventListener("click", function(e) {
          e.preventDefault();
          const attributes = [].map.call(e.target.attributes, function (el) {
            return el;
          });
          let iframe = d.createElement('iframe')
          iframe.src = wh + '/?' + attributes
            .filter(function (e) {
              return e.nodeName.match(/^data-crypto-widget/g);
            })
            .map(function (e) {
              return e.nodeName.replace(attr + '-', '') + '=' + e.nodeValue;
            })
            .join('&');
          [].map.call(style.split(';'), function (el) {
            let attr = el.split(':');
            iframe.style[attr[0]] = attr[1]
          });
          d.body.appendChild(iframe);
          window.addEventListener('message', function (event) {
            event.origin.indexOf(wh) !== -1 && event.data == 'close' && iframe.parentNode && iframe.parentNode.removeChild(iframe); // IE11 fix :(
          });
        });
      }
    }
  }

  loadWidget() {
    if(!this.state.wloaded) {
      this.setState({wloaded: true});
      setTimeout(() => {
        this.bindWidget();
        window.addEventListener('widget-rebind', this.bindWidget);
      },1000);
    }
  }



  render() {
    let Order = {};
    if(this.props.CreateOrder.Loaded) {
      Order = this.props.CreateOrder.Result.Result;
      this.loadWidget();
    }

    return (
      <React.Fragment>
        {!this.props.CreateOrder.Loaded &&
        <React.Fragment>
          <div className="large-text">{this.getTranslation("dash.pleasewait")}</div>
          <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
            <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
          </p>
        </React.Fragment>
        }
        {(this.props.CreateOrder.Loaded && this.state.step == "") &&
        <div style={{flexDirection: "column",display: "flex",alignContent: "center", justifyContent: "center", alignItems: "center"}}>
          <h1 style={{textAlign: "center", marginTop: "0px"}}>Click the button to load Secure Payment</h1>
          <button style={{padding: "0px 75px", width: "50%" }}
            data-crypto-widget-partner-id="cd9e28ae-c255-11e9-9cb5-2a2ae2dbcce4"
            data-crypto-widget-client-id={this.props.WebPage.User.UserId}
            data-crypto-widget-email={this.props.WebPage.User.EmailAddress}
            data-crypto-widget-amount={Order.Data[0]}
            data-crypto-widget-currency="EUR"
            data-crypto-widget-order-id={Order.OrderId}
          >{this.getTranslation("page.submit")}</button>
        </div>
        }
        {this.state.step == "SUCCESS" &&
          <OrderAccepted
            OrderId = {Order.OrderId}
            Message = "Success"
          />
        }
        {this.state.step == "FAILED" &&
          <OrderDeclined
            OrderId = {Order.OrderId}
            Message = "Failed.."
            handleBackToBilling = {(e) => {this.props.handleBackToBilling(e)}}
          />
        }

        <div className="sep m-t-l"></div>
        <div className="clear"></div>


        <div className="full">
          <input type="submit" value={this.getTranslation("page.profile.previous")} onClick={(e) => { e.preventDefault(); this.props.handleBackToBilling(e)}}/>
        </div>

        <div className="secure-div">
          <img src="/imgs/billing/secure-site.png" alt="" style={{margin: "50px auto"}}/>
        </div>


      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    CreateOrder: state.Billing.CreateOrder,
    Billing: state.Billing.BillingData
  };
}

export default connect(mapStateToProps)(LoadBillerJivo);




